import RolesDrawer from '@/components/common/rolesDrawer/RolesDrawer';
import { Footer } from '@/components/layout/Footer.tsx';
import { GlobalToasts } from '@/components/layout/GlobalToasts';
import { Header } from '@/components/layout/Header.tsx';
import {
  UserPreferencesInitializer,
  UserPreferencesUpdater,
} from '@/components/layout/userPreferences';
import PositionDetailsDrawer from '@/components/root/details/tabs/detailedValuation/grid/positionDetailsDrawer/PositionDetailsDrawer';
import SigmaOrderHistoryDrawer from '@/components/root/details/tabs/operationFuture/sigmaOrderHistory/SigmaOrderHistoryDrawer';
import { getConfig } from '@/config/config.ts';
import '@/routes/root.css'; // Layout of the page header/main/footer
import { SgwtSplashScreen, SgwtWebAnalytics } from '@sgwt/sgwt-widgets-react';
import { Outlet, createRootRoute } from '@tanstack/react-router';
import React, { Suspense } from 'react';

const TanStackRouterDevtools =
  getConfig().environment === 'prod'
    ? () => null // Render nothing in production
    : React.lazy(() =>
      // Lazy load in development
      import('@tanstack/router-devtools').then((res) => ({
        default: res.TanStackRouterDevtools,
        // For Embedded Mode
        // default: res.TanStackRouterDevtoolsPanel
      })),
    );

export const Route = createRootRoute({
  component: () => {
    const { matomo } = getConfig();

    return (
      <div className="app">
        <Header />

        <main>
          <UserPreferencesInitializer />
          <UserPreferencesUpdater />
          <Outlet />
          <RolesDrawer />
          <PositionDetailsDrawer />
          <SigmaOrderHistoryDrawer />
          <GlobalToasts />
          <Suspense>
            <TanStackRouterDevtools />
          </Suspense>
        </main>

        <Footer />

        <SgwtSplashScreen applicationId={import.meta.env.VITE_APP_ID} />
        <SgwtWebAnalytics siteId={matomo.siteId} baseUrl={matomo.url} debug={true} />
      </div>
    );
  },
});
